module.exports = __webpack_public_path__ + "img/SWIFT-alt.2586b1c4.svg";